import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CookiesService } from 'src/app/services/cookies.service';
import { fadeInOut } from '../../../animations';
import { MenuItemModel } from '../../../models/menu/menu-item.model';
import { MenuStateModel } from '../../../models/menu/menu-state.model';
import { NavigationService } from '../../../navigation/services/navigation.service';
import { MenuService } from '../../../services/menu/menu.service';
import { MenuItemLeftComponent } from './menu-item-left/menu-item-left.component';

@Component({
  selector: 'app-menu-left',
  templateUrl: './menu-left.component.html',
  styleUrls: ['./menu-left.component.scss'],
  animations: [fadeInOut],
})
export class MenuLeftComponent implements OnInit {
  menuLeft: Array<MenuItemModel>;
  menuTop: Array<MenuItemModel>;

  subs: Subscription[] = [];

  @Input() menuState: MenuStateModel;
  @ViewChildren(MenuItemLeftComponent) menuItems: QueryList<MenuItemLeftComponent>;
  selectedMenu: MenuItemModel;
  public version = JSON.parse(this.cookieService.getCookie('version'))?.version

  constructor(public menuService: MenuService, private router: Router, private navigationService: NavigationService, private cookieService: CookiesService) {}

  get isMenuLoaded(): boolean {
    return this.menuLeft != null && this.menuTop != null;
  }

  ngOnInit() {
    this.loadAllMenus();
  }

  navigateToAccueil() {
    this.navigationService.root.accueil.navigate();
    return false;
  }

  closeMenuMobile() {
    this.menuState.isMenuMobileOpened = false;
  }

  private loadAllMenus(): void {
    this.subs.push(this.menuService.getMenuLeft().subscribe(menu => (this.menuLeft = menu)));
    this.subs.push(this.menuService.getMenuTop().subscribe(menu => (this.menuTop = menu)));
  }

  onMenuClicked(menuItem: MenuItemModel) {
    this.selectedMenu = menuItem;
  }

  isSelected(menuItem: MenuItemModel) {
    return menuItem == this.selectedMenu;
  }

  public navigateToMarketPlace(){
    window.open('https://espaceclient.eparcours.axess.fr/MarketPlace', '_blank');
  }
}
